import * as React from "react";

interface NavbarProps {
  children?: React.ReactNode; // For the right side content
  maxWidth?: string; // e.g. "max-w-7xl" or "max-w-5xl"
  leftContent?: React.ReactNode; // For the navigation links
  className?: string;
}

export const Navbar = ({ children, maxWidth = "max-w-5xl", leftContent, className = "mt-6" }: NavbarProps) => {
  return (
    <section className={`px-6 sm:px-12 ${className}`}>
      <div className={`${maxWidth} mx-auto flex items-center justify-between`}>
        <div className="flex items-center gap-2 text-sm">
            {leftContent}
        </div>
        <div className="flex items-center gap-4">
            {children}
        </div>
      </div>
    </section>
  );
};

interface NavbarLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    active?: boolean;
}

export const NavbarLink = ({ active, className = "", children, ...props }: NavbarLinkProps) => {
    return (
        <button
            className={`font-normal ${active ? 'text-black border-b border-black pb-0.5 leading-none' : 'text-neutral-400 hover:text-black'} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export const NavbarSeparator = () => (
    <span className="text-neutral-400 font-light">/</span>
);
